import {ApexOptions} from 'apexcharts';
import {Component} from 'react';
import ReactApexChart from 'react-apexcharts';

//
interface spark3 {
  options?: ApexOptions;
  width?: string | number;
  height?: string | number;
  series?: ApexOptions['series'];
  label?: XAxisAnnotations;
  endingShape?: string;
}
export class Totalcustomers extends Component<Record<string, never>, spark3> {
  constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
    super(props);

    this.state = {
      series: [
        {
          name: 'Value',
          data: [20, 14, 19, 10, 23, 20, 22, 9, 12],
        },
      ],
      options: {
        colors: ['rgb(132, 90, 223)'],
        chart: {
          type: 'line',
          height: 40,
          width: 100,
          sparkline: {
            enabled: true,
          },
          events: {
            mounted: (chart: any) => {
              chart.windowResizeHandler();
            },
          },
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 1.5,
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.9,
            opacityTo: 0.9,
            stops: [0, 98],
          },
        },
        yaxis: {
          min: 0,
          show: false,
          axisBorder: {
            show: false,
          },
        },
        xaxis: {
          // show: false,
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    };
  }

  render() {
    return (
      <div>
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={40} width={100} />
      </div>
    );
  }
}
//
export class Totalrevenue extends Component<Record<string, never>, spark3> {
  constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
    super(props);

    this.state = {
      series: [
        {
          name: 'Value',
          data: [20, 14, 20, 22, 9, 12, 19, 10, 25],
        },
      ],
      options: {
        colors: ['rgb(35, 183, 229)'],
        chart: {
          type: 'line',
          height: 40,
          width: 100,
          sparkline: {
            enabled: true,
          },
          events: {
            mounted: (chart: any) => {
              chart.windowResizeHandler();
            },
          },
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 1.5,
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.9,
            opacityTo: 0.9,
            stops: [0, 98],
          },
        },
        yaxis: {
          min: 0,
          show: false,
          axisBorder: {
            show: false,
          },
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    };
  }

  render() {
    return (
      <div>
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={40} width={100} />
      </div>
    );
  }
}

//
export class Conversionratio extends Component<Record<string, never>, spark3> {
  constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
    super(props);

    this.state = {
      series: [
        {
          name: 'Value',
          data: [20, 20, 22, 9, 14, 19, 10, 25, 12],
        },
      ],
      options: {
        colors: ['rgb(38, 191, 148)'],
        chart: {
          type: 'line',
          height: 40,
          width: 100,
          sparkline: {
            enabled: true,
          },
          events: {
            mounted: (chart: any) => {
              chart.windowResizeHandler();
            },
          },
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 1.5,
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.9,
            opacityTo: 0.9,
            stops: [0, 98],
          },
        },

        yaxis: {
          min: 0,
          show: false,
          axisBorder: {
            show: false,
          },
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    };
  }

  render() {
    return (
      <div>
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={40} width={100} />
      </div>
    );
  }
}
//
export class Totaldeals extends Component<Record<string, never>, spark3> {
  constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
    super(props);

    this.state = {
      series: [
        {
          name: 'Value',
          data: [20, 20, 22, 9, 12, 14, 19, 10, 25],
        },
      ],
      options: {
        colors: ['rgb(245, 184, 73)'],
        chart: {
          type: 'line',
          height: 40,
          width: 100,
          sparkline: {
            enabled: true,
          },
          events: {
            mounted: (chart: any) => {
              chart.windowResizeHandler();
            },
          },
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 1.5,
          dashArray: 0,
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.9,
            opacityTo: 0.9,
            stops: [0, 98],
          },
        },
        yaxis: {
          min: 0,
          show: false,
          axisBorder: {
            show: false,
          },
        },
        xaxis: {
          // show: false,
          axisBorder: {
            show: false,
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    };
  }

  render() {
    return (
      <div>
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={40} width={100} />
      </div>
    );
  }
}

export const marketData = [
  {
    ID: 1,
    Name: 'Los Angeles',
    Symbol: 'CA - LA',
    Sales: '$682,398,230.23',
    MarketCap: '$1,457,034,570.57',
    'Price Graph': 'bitcoin-price-graph',
    Volume: 14674311168,
    PriceChange: '0.30%',
  },
  {
    ID: 2,
    Name: 'San Diego',
    Symbol: 'CA - SD',
    Sales: '$1,457,034,570.57',
    MarketCap: '$149,316,232,699.00',
    'Price Graph': 'etherium-price-graph',
    Volume: 4758554801,
    PriceChange: '0.30%',
  },
  {
    ID: 3,
    Name: 'Orange',
    Symbol: 'CA - OR',
    Sales: '$1,273,205,345.67',
    MarketCap: '$145,678,902,345.00',
    'Price Graph': 'orange-price-graph',
    Volume: 3567892234,
    PriceChange: '0.20%',
  },
  {
    ID: 4,
    Name: 'Riverside',
    Symbol: 'CA - RI',
    Sales: '$923,456,789.12',
    MarketCap: '$134,567,890,123.00',
    'Price Graph': 'riverside-price-graph',
    Volume: 2456789012,
    PriceChange: '-0.10%',
  },
  {
    ID: 5,
    Name: 'San Bernardino',
    Symbol: 'CA - SB',
    Sales: '$782,123,456.78',
    MarketCap: '$123,456,789,012.00',
    'Price Graph': 'sanbernardino-price-graph',
    Volume: 1789012345,
    PriceChange: '0.15%',
  },
  {
    ID: 6,
    Name: 'Sacramento',
    Symbol: 'CA - SC',
    Sales: '$689,234,567.89',
    MarketCap: '$112,345,678,901.00',
    'Price Graph': 'sacramento-price-graph',
    Volume: 1234567890,
    PriceChange: '0.25%',
  },
  {
    ID: 7,
    Name: 'Santa Clara',
    Symbol: 'CA - SC',
    Sales: '$567,890,123.45',
    MarketCap: '$101,234,567,890.00',
    'Price Graph': 'santaclara-price-graph',
    Volume: 987654321,
    PriceChange: '0.10%',
  },
  {
    ID: 8,
    Name: 'Alameda',
    Symbol: 'CA - AL',
    Sales: '$456,789,012.34',
    MarketCap: '$90,123,456,789.00',
    'Price Graph': 'alameda-price-graph',
    Volume: 876543210,
    PriceChange: '0.05%',
  },
  {
    ID: 9,
    Name: 'Contra Costa',
    Symbol: 'CA - CC',
    Sales: '$345,678,901.23',
    MarketCap: '$80,012,345,678.00',
    'Price Graph': 'contracosta-price-graph',
    Volume: 765432109,
    PriceChange: '-0.05%',
  },
  {
    ID: 10,
    Name: 'Fresno',
    Symbol: 'CA - FR',
    Sales: '$234,567,890.12',
    MarketCap: '$70,901,234,567.00',
    'Price Graph': 'fresno-price-graph',
    Volume: 654321098,
    PriceChange: '0.15%',
  },
];
